import { bool, string } from 'prop-types';
import {
  Button,
  CircularProgress,
} from '@material-ui/core';
import arrowRight from './images/arrow-right.svg';

function ButtonControl(props) {
  const {
    className,
    color,
    disabled,
    fullWidth = true,
    form,
    label,
    loaderAlign = 'left',
    processing,
    showArrow = true,
    type,
  } = props;

  const showInlineLoader = processing && showArrow === false && loaderAlign === 'center';

  return (
    <Button
      className={className}
      color={color}
      disabled={processing || disabled}
      form={form}
      fullWidth={fullWidth}
      size="large"
      startIcon={showInlineLoader ? undefined : (processing ? <CircularProgress
        size={18}
        style={{
          marginRight: 5,
        }}
      /> : undefined)}
      type={type}
      variant="contained"
    >
      <div style={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: showArrow ? 'space-between' : 'center',
      }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: showArrow ? 'flex-start' : 'center',
            width: showArrow ? 'auto' : '100%',
          }}
        >
          {showInlineLoader && (
            <CircularProgress
              size={18}
              style={{
                marginRight: 8,
              }}
            />
          )}
          <span>{label}</span>
        </div>
        {showArrow && <div><img src={arrowRight} alt={label} /></div>}
      </div>
    </Button>

  );
}

ButtonControl.propTypes = {
  className: string,
  color: string,
  disabled: bool,
  fullWidth: bool,
  form: string,
  label: string,
  loaderAlign: string,
  processing: bool,
  showArrow: bool,
  type: string,
};

export default ButtonControl;
